import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import login from '@/components/login'
import exit from '@/components/exit'
import creatOrder from '@/components/creatOrder'
import orderDetail from '@/components/orderDetail'
import assignationManagement from '@/components/assignationManagement'
import car from '@/components/car'
import lineItem from '@/components/lineItem'
import refuelingpoint from '@/selfhelp/refuelingpoint'
import therefuel from '@/selfhelp/therefuel'
import siteList from '@/components/siteList'
import { MessageBox } from 'mint-ui';
Vue.use(Router)

const myRouter=new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path:'/login',
      name:'login',
      component:login
    },
    {
      path:'/sitelist',
      name:'siteList',
      component:siteList
    },
    {
      path:'/exit',
      name:'exit',
      component:exit
    },{
      path:'/creatOrder/:id',
      name:'creatOrder',
      component:creatOrder
    },{
      path:'/orderDetail/:order_id',
      name:'orderDetail',
      component:orderDetail
    },{
      path:"/assignationManagement/:card_obj",
      name:"assignationManagement",
      component:assignationManagement
    },{
      path:"/lineItem",
      name:"lineItem",
      component:lineItem
    },{
      path:"/refuelingpoint/:tankernum",
      name:"refuelingpoint",
      component:refuelingpoint
    },{
      path:"/therefuel/:facility",
      name:"therefuel",
      component:therefuel
    },
    {
      path:"/car",
      name:"car",
      component:car
    }
  ]
});

myRouter.beforeEach((to, from, next) => {
  if (to.query.abc) {
    next();
    return;
  };
  if (from.query.abc) {
      let toQuery = JSON.parse(JSON.stringify(to.query));
      toQuery.abc = from.query.abc;
      next({
          path: to.path,
          query: toQuery
      })
  } else {
      to.query.abc = 111
      next()
  }
});
export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js